import { FormFields, Icons, Label } from "components";


const RewardHighestScore = ({ control, disabled }) => {
  const rewardFields = [
    { name: "reward_1st_amount", label: "รางวัลอันดับที่ 1", subLabel: "The Winner" },
    { name: "reward_2nd_amount", label: "รางวัลอันดับที่ 2", subLabel: "1st Runner-up" },
    { name: "reward_3rd_amount", label: "รางวัลอันดับที่ 3", subLabel: "2nd Runner-up" },
    { name: "reward_consolation_amount", label: "รางวัลอันดับที่ 4 เป็นต้นไป", subLabel: "Consolation Prize" },
  ];

  return (
    <div className="row_4col">
      {rewardFields.map((item) => (
        <div key={item.name}>
          <FormFields.FormTextField
            theme_standard_new
            label={item.label}
            subLabel={item.subLabel}
            required
            control={control}
            useComma
            type="number"
            name={item.name}
            iconInlinePrefix={
              <Label.LabelInlineIcon theme_standard_label_inline_icon icon={<Icons.Dumbel2 />} label="คะแนนสุขภาพ" />
            }
            iconRight={'แต้ม'}
            maxLength={4}
            placeholder="คะแนน"
            paddingInput="10px"
            disabled={disabled}
          />
        </div>
      ))}
    </div>
  );
};

export default RewardHighestScore;
